export const MY_PLACE_CARD_SIZE = 180;
export const CARD_CONTENT_HEIGHT = 50;
export const CARD_CONTENT_MEDIA_MD = 150;
export const CARD_CONTENT_MEDIA_LG = 180;

export const SUPPORTED_VIDEO_EXTENSION = ["mp4", "webm"];
